import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login-redirec',
    template: ``,
    styles: [``],
})
export class LoginComponentRedirect implements OnInit {

    constructor(
        public router : Router
    ) {
    }

    ngOnInit(): void {
        window.location.href = 'https://erp.epaysay.com'
    }



}
